/* This is a mst-gql generated file, don't modify it manually */
 

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"


/**
 * FindAProviderConfigBase
 * auto generated base class for the model FindAProviderConfigModel.
 *
 * A Partners find a provider config
 */
export const FindAProviderConfigModelBase = ModelBase
  .named('FindAProviderConfig')
  .props({
    __typename: types.optional(types.literal("FindAProviderConfig"), "FindAProviderConfig"),
    isAppointmentDateFilterEnabled: types.union(types.undefined, types.null, types.boolean),
    isAppointmentTimeFilterEnabled: types.union(types.undefined, types.null, types.boolean),
    isAcceptsOnlineBookingFilterEnabled: types.union(types.undefined, types.null, types.boolean),
    isDirectionsButtonEnabled: types.union(types.undefined, types.null, types.boolean),
    isLanguageFilterEnabled: types.union(types.undefined, types.null, types.boolean),
    isLoadAllLocationsButtonEnabled: types.union(types.undefined, types.null, types.boolean),
    isLoadAllLocationsEnabled: types.union(types.undefined, types.null, types.boolean),
    isProviderNameFilterEnabled: types.union(types.undefined, types.null, types.boolean),
    isShowOnlyClaimedAccountsEnabled: types.union(types.undefined, types.null, types.boolean),
    isShowProviderResultsEnabled: types.union(types.undefined, types.null, types.boolean),
    isSpecialtyFilterEnabled: types.union(types.undefined, types.null, types.boolean),
    allowedSpecialties: types.union(types.undefined, types.null, types.array(types.string)),
    defaultSpecialty: types.union(types.undefined, types.null, types.string),
    partnerTagLabel: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore()
    }
  }))

export class FindAProviderConfigModelSelector extends QueryBuilder {
  get isAppointmentDateFilterEnabled() { return this.__attr(`isAppointmentDateFilterEnabled`) }
  get isAppointmentTimeFilterEnabled() { return this.__attr(`isAppointmentTimeFilterEnabled`) }
  get isAcceptsOnlineBookingFilterEnabled() { return this.__attr(`isAcceptsOnlineBookingFilterEnabled`) }
  get isDirectionsButtonEnabled() { return this.__attr(`isDirectionsButtonEnabled`) }
  get isLanguageFilterEnabled() { return this.__attr(`isLanguageFilterEnabled`) }
  get isLoadAllLocationsButtonEnabled() { return this.__attr(`isLoadAllLocationsButtonEnabled`) }
  get isLoadAllLocationsEnabled() { return this.__attr(`isLoadAllLocationsEnabled`) }
  get isProviderNameFilterEnabled() { return this.__attr(`isProviderNameFilterEnabled`) }
  get isShowOnlyClaimedAccountsEnabled() { return this.__attr(`isShowOnlyClaimedAccountsEnabled`) }
  get isShowProviderResultsEnabled() { return this.__attr(`isShowProviderResultsEnabled`) }
  get isSpecialtyFilterEnabled() { return this.__attr(`isSpecialtyFilterEnabled`) }
  get allowedSpecialties() { return this.__attr(`allowedSpecialties`) }
  get defaultSpecialty() { return this.__attr(`defaultSpecialty`) }
  get partnerTagLabel() { return this.__attr(`partnerTagLabel`) }
}
export function selectFromFindAProviderConfig() {
  return new FindAProviderConfigModelSelector()
}

export const findAProviderConfigModelPrimitives = selectFromFindAProviderConfig().isAppointmentDateFilterEnabled.isAppointmentTimeFilterEnabled.isAcceptsOnlineBookingFilterEnabled.isDirectionsButtonEnabled.isLanguageFilterEnabled.isLoadAllLocationsButtonEnabled.isLoadAllLocationsEnabled.isProviderNameFilterEnabled.isShowOnlyClaimedAccountsEnabled.isShowProviderResultsEnabled.isSpecialtyFilterEnabled.allowedSpecialties.defaultSpecialty.partnerTagLabel
